import React from 'react';
import PropTypes from 'prop-types';

import OEMainMenuBar from '../../main-menu/oe-main-menu-bar';
import OEToolbox from '../../../../lib/tools/oe-toolbox';

export default class OEStdCapBarMainMenuBar extends React.PureComponent {

    constructor(props) {
        super(props);
    }

    render() {
        const {className, style, leftSpacer, rightSpacer, ...rest} = this.props;

        return (
            <div className={'std-cap-bar-main-menu-bar ' + className} style={style}>

                {leftSpacer ? <div className="light-bg-border spacer-flex"/> : null}

                <OEMainMenuBar tooltipPlacement="bottom" {...rest}/>

                {rightSpacer ? <div className="light-bg-border spacer-flex"/> : null}

            </div>
        );
    }
}

OEStdCapBarMainMenuBar.defaultProps = Object.assign({}, {
    className: '',
    leftSpacer: false,
    rightSpacer: false
}, OEToolbox.filterObject(OEMainMenuBar.defaultProps, null, ['tooltipPlacement']));

OEStdCapBarMainMenuBar.propTypes = Object.assign({}, {
    className: PropTypes.string,
    style: PropTypes.object,
    leftSpacer: PropTypes.bool,
    rightSpacer: PropTypes.bool,
}, OEToolbox.filterObject(OEMainMenuBar.propTypes, null, ['tooltipPlacement']));